import {Tr} from "@/i18n/i18n";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {ManualLink} from "@/scenes.ui/manual-link";
import PlayerStore from "@/store/player";
import {WheelStatusDto} from "@/store/player/types";
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";
import {WingedLongPanel} from "@/scenes.ui/winged-long-panel";
import {CampaignWheelPanel} from "@/scenes.ui/campaign-wheel-panel";
import {StringUtils} from "@/utils/string-utils";
import {InsufficientTicketsPanel} from "@/scenes.ui/insufficient-tickets-panel";
import {ChestContentType, WheelContentDto} from "@/store/chest/types";
import {ForceUtils} from "@/utils/force-utils";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {PickCreaturePanel} from "@/scenes.ui/pick-creature-panel";
import SkillUtils from "@/utils/skill-utils";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import Scene = Phaser.Scene;
import BaseSound = Phaser.Sound.BaseSound;
import {Container} from "inversify";
import CU from "@/utils/c-u";
import OnceCaller from "@/utils/once-caller";

export class CampaignWheelPanel2 extends WingedLongPanel {

    private static MAX_TICKETS_OF_ALL_TIME_FOR_AUTO_ROTATE_CHECKBOX = 1000;
    private static ANGLE_PER_SECOND = Math.PI / 4  * 180 ;

    private shopCallback: (() => unknown) | undefined;

    public static singleton : CampaignWheelPanel2 | undefined;

    private dto!:WheelStatusDto;
    private updaters: { (): void; }[] = [];
    private elements: (Phaser.GameObjects.Sprite|Phaser.GameObjects.Text|CreaturePanel)[] = [];

    private wheel!: Phaser.GameObjects.Sprite;
    private cursor!: Phaser.GameObjects.Sprite;
    private choosenText!: Phaser.GameObjects.Text;

    private targetAngle = 0;
    private srcAngle = 0;
    private currentAngle = 0;
    private onStopWheelCallback!: (() => unknown) | undefined;
    private spinButtonEnabled = true;
    private tickets = 0;


    constructor(scene: Scene, canvas: HTMLCanvasElement, clickSound: BaseSound | undefined, shopCallback: () => unknown, wheelDto:WheelStatusDto) {
        super(scene, canvas, Tr('c.wheel'));
        this.dto = Object.assign({}, wheelDto);

        // if(wheelDto.rewards.filter(r=> r.chosen).length > 0){
        //     this.targetAngle = 15 * 360/16;
        // }

        CampaignWheelPanel2.singleton = this;

        this.shopCallback = shopCallback;
        let self = this;
        let bgBottom = SpriteUtils.addSprite(scene, 0, 252-46, Keys.WHEEL_BG_BOTTOM, undefined, 1.395).setOrigin(0.5, 0);
        let shine = SpriteUtils.addSprite(scene, 0, -30+20, Keys.WHEEL_SPLASH_2, undefined, 1.1);
        let wheel = SpriteUtils.addSprite(scene, 0, -30+20, Keys.WHEEL, undefined, 1.1);
        this.wheel = wheel;
        let cursor = SpriteUtils.addSprite(scene, 0, -190, Keys.WHEEL_CURSOR, undefined, 1);
        this.cursor = cursor;

        let backButton = SpriteUtils.addImage(scene, -165-25, -200, Keys.WHEEL_BACK_BTN).setOrigin(0.5, 0.5);
        backButton.setInteractive().on('pointerup', function() {
            PlayerStore.fetchWheelCampaignStatus().then((dto: WheelStatusDto) => {
                let ccp: CampaignWheelPanel = new CampaignWheelPanel(scene, canvas, clickSound, shopCallback, dto);
                ccp.openAnimated();
                self.close();
            });
        }).setVisible(this.isClosable());

        let player = PlayerStore.getPlayer();
        this.tickets = player.tickets;
        let spinButton = SpriteUtils.addImage(scene, 0, 250-30+40, Keys.WHEEL_ROLL_BTN).setOrigin(0.5, 0.5);

        this.drawRewards(self.elements);

        spinButton.setInteractive().on('pointerup', function() {
            // OnceCaller.doOnce("spinnWheel", () => {
            if (self.targetAngle > self.currentAngle || !self.spinButtonEnabled) {
                return;
            }

            if (self.dto.rewards.filter(r => r.chosen).length > 0) {
                let chosen = self.dto.rewards.filter(r => r.chosen)[0];
                SoundUtils.play(clickSound);

                let picking = false;
                let cc = chosen;
                if (cc.creatureIds && cc.creatureIds.length > 0) {
                    picking = true;

                    let ccs = PlayerStore.getPlayer().creatures.filter(c => cc.creatureIds.includes(c.id));
                    let pickCreaturePanel = new PickCreaturePanel(self.scene, self.canvas, cc, ccs, (cId: number) => {
                        self.spinButtonEnabled = false;
                        spinButton.alpha = 0.5;
                        PlayerStore.takeRewardFromWheel(cId).then((dto: WheelStatusDto) => {
                            self.spinButtonEnabled = true;
                            spinButton.alpha = 1;
                            self.updateState(dto);
                            new FeedbackPanel(self.scene, self.getRewardDesc(cc.chestContentType) + "!", undefined, true).show();
                            // wheel.angle = 0;
                        });
                    })
                    pickCreaturePanel.openAnimated();
                }

                if (!picking) {
                    self.spinButtonEnabled = false;
                    spinButton.alpha = 0.5;
                    PlayerStore.takeRewardFromWheel(null).then((dto: WheelStatusDto) => {
                        self.spinButtonEnabled = true;
                        spinButton.alpha = 1;
                        console.log("takeRewardFromWheel", dto)
                        self.updateState(dto);
                        new FeedbackPanel(self.scene, self.getRewardDesc(cc.chestContentType) + "!", undefined, true).show();
                    });
                }
            } else if (self.dto.freeSpins > 0) {
                self.spinButtonEnabled = false
                spinButton.alpha = 0.5;
                PlayerStore.spinWheel().then((dto: WheelStatusDto) => {
                    self.spinButtonEnabled = true;
                    spinButton.alpha = 1;
                    if (dto && dto.rewards) {
                        self.targetAngle = self.calculateTargetAngle(dto) * 180 / Math.PI;
                        self.currentAngle = self.wheel.angle;
                        self.srcAngle = self.wheel.angle;
                        self.targetTimeMillis = new Date().getTime() + (self.targetAngle - self.currentAngle) / CampaignWheelPanel2.ANGLE_PER_SECOND * 1000;
                        self.updateState(dto, true);
                        console.log("spin")
                    }
                });
            } else if (self.tickets >= self.dto.ticketsForSpin) {
                self.tickets -= self.dto.ticketsForSpin;
                self.spinButtonEnabled = false;
                spinButton.alpha = 0.5;
                PlayerStore.spinWheel().then((dto: WheelStatusDto) => {
                    self.spinButtonEnabled = true;
                    spinButton.alpha = 1;
                    if (dto && dto.rewards) {
                        self.targetAngle = self.calculateTargetAngle(dto) * 180 / Math.PI;
                        self.currentAngle = self.wheel.angle;
                        self.srcAngle = self.wheel.angle;
                        self.targetTimeMillis = new Date().getTime() + (self.targetAngle - self.currentAngle) / CampaignWheelPanel2.ANGLE_PER_SECOND * 1000;
                        self.updateState(dto, true);
                        console.log("spin")
                    }
                });
            } else {
                let p = new InsufficientTicketsPanel(scene, canvas, 300, canvas.height / 2 - 50, self.dto.ticketsForSpin - self.tickets, () => {
                    shopCallback();
                    self.setVisible(false);
                    self.destroy();
                    p.setVisible(false);
                    p.destroy();
                });
                p.open();
            }
            // }, 1000);
        }).setVisible(this.isClosable());

        let shine2 = SpriteUtils.addSprite(scene, 0, -190 + 50, Keys.WHEEL_SPLASH, undefined, 1.1);
        shine2.setAlpha(0);

        // let sectorHighlight = SpriteUtils.addSprite(scene, -1, -190 + 45+40, Keys.WHEEL_SECTOR_PRIZE, undefined, 1.1);
        let sectorHighlight = SpriteUtils.addSprite(scene, 0, -190, Keys.WHEEL_CURSOR_2, undefined, 1);
        sectorHighlight.setAlpha(0);


        let buttonText = this.scene.add.text(0, (205+40)*CU.S, this.getSpinText(this.dto),{
            fontSize: String(Math.ceil(14 * CU.S)) + 'pt',
            color: '#ebbd6d',
            fontFamily: Fonts.ARIAL_MT,
            align: 'center',
            fontStyle: 'normal',
            wordWrap: { width: 175, useAdvancedWrap: true }
        }).setOrigin(0.5, 0.5);
        self.updaters.push(()=> {
            if(!self.dto.rewards) {
                console.log("self.dto", self.dto)
            }
            if(self.dto && self.dto.rewards && self.dto.rewards.filter(r=> r.chosen).length > 0 && this.targetAngle <= this.currentAngle){
                buttonText.text = Tr('take.award');
                buttonText.y = (215+40)*CU.S;

                shine2.setAlpha(1);
                sectorHighlight.setAlpha(0);
                self.bringToTop(sectorHighlight);
                SpriteUtils.scale(shine2, 1.5);
                SpriteUtils.scale(sectorHighlight, 1, 1);
                this.scene!.tweens.add({
                    targets: [shine2],
                    delay: 0,
                    duration:  1000,
                    props: {
                        scale: {value: 0.5, ease: 'Cubic.easeInOut'},
                        alpha: {value: 0, ease: 'Cubic.easeInOut'},
                    }
                });
                function customEase(t:number) {
                    // Пример функции, которая приближается к 1 три раза
                    return Math.sin(t * Math.PI * 3) * (1 - t) + t;
                }
                this.scene!.tweens.add({
                    targets: sectorHighlight,
                    delay: 0,
                    duration:  800,
                    ease: customEase,
                    props: {
                        alpha: {value: 0.9},
                    }
                });
                if(this.choosenText && this.choosenText.visible){
                    // this.choosenText.setFontSize(Math.ceil(15 * CU.S));
                    SpriteUtils.scale(this.choosenText, 1);
                    this.choosenText.setColor("#89fa78");
                }
            } else {
                buttonText.text = this.getSpinText(this.dto);
                buttonText.y = this.dto.freeSpins >0? (215+40)*CU.S : (205+40)*CU.S;
            }
        });

        let haveTickets = TextUtils.addTextByFamily(scene, this.getAvailableSpinsText(this.dto, self.tickets), 20 + (self.tickets>=10? 5 : 0) + (self.tickets>=100? 5 : 0) , 250+10+30+40,
            '#c2c2c2', 14, 'normal', 420, Fonts.ARIAL_MT).setOrigin(0.5,0.5);
        self.updaters.push(()=> {
            haveTickets.text = this.getAvailableSpinsText(this.dto, self.tickets);
            haveTickets.setOrigin(this.dto.freeSpins >0? 0.5 : 1,0.5);
            haveTickets.x = this.dto.freeSpins >0? 0 : 20  + (self.tickets>=10? 5 : 0) + (self.tickets>=100? 5 : 0)
        });

        let ticket1 = SpriteUtils.addSprite(scene, 25 + (self.tickets>=10? 5 : 0) + (self.tickets>=100? 5 : 0), 250+10+30+40, Keys.IMG_TICKET, undefined, 0.5).setOrigin(0,0.5);
        let ticket2 = SpriteUtils.addSprite(scene, 0,  250-30+15+40, Keys.IMG_TICKET, undefined, 0.8);
        self.updaters.push(()=> {ticket2.visible = (this.dto.freeSpins <= 0) && (self.dto.rewards.filter(r=> r.chosen).length == 0 ||  this.targetAngle > this.currentAngle)});
        self.updaters.push(()=> {ticket1.visible = (this.dto.freeSpins <= 0); ticket1.x = 25 + (self.tickets>=10? 5 : 0) + (self.tickets>=100? 5 : 0)});
        self.updaters.forEach(u=>{u()});

        let haveAutoRotationCheckbox = wheelDto.ticketsMaxOfAllTime >= CampaignWheelPanel2.MAX_TICKETS_OF_ALL_TIME_FOR_AUTO_ROTATE_CHECKBOX;

        let chancesInfo = new ManualLink(scene, canvas, 190-33, -190-33, 'wheelChances', Tr('wheel.det'), '#D0D0D0', true);
        chancesInfo.visible = !haveAutoRotationCheckbox;

        let autoRotationText = this.scene.add.text((190-33-77-7+107) * CU.S, (-190-60+25) * CU.S, Tr('auto.rotation'),{
            fontSize: String(Math.ceil(13 * CU.S)) + 'pt',
            color: '#979798',
            fontFamily: Fonts.ARIAL_MT,
            align: 'center',
            fontStyle: 'normal',
            wordWrap: { width: 350, useAdvancedWrap: true }
        });
        autoRotationText.setOrigin(1, 0)
        autoRotationText.alpha = 0.7;
        autoRotationText.visible = haveAutoRotationCheckbox;

        let autoRotateButton = this.addCustomButton(190-33+50, -190-23, "", Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, "",() =>{
            PlayerStore.setWheelAutoRotate(true);
            autoRotateButton.visible = false;
            manualRotateButton.visible = true;
        }, true);
        autoRotateButton.setScale(0.25, 0.25);
        autoRotateButton.visible = haveAutoRotationCheckbox && !PlayerStore.isWheelAutoRotate();

        let manualRotateButton = this.addCustomButton(190-33+50, -190-23, "", Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {
            PlayerStore.setWheelAutoRotate(false);
            autoRotateButton.visible = true;
            manualRotateButton.visible = false;
        }, true);
        manualRotateButton.setScale(0.25, 0.25);
        manualRotateButton.visible = haveAutoRotationCheckbox && PlayerStore.isWheelAutoRotate();

        let campaignInfo = TextUtils.addTextByFamily(scene, StringUtils.formatString(Tr('tickets.conds'),
                CampaignWheelPanel.TICKET_PER_EMERALDS).toUpperCase(),
            0, 115+338-80, '#b39b5d', 13, 'normal', 380, Fonts.MYRIADPRO_REGULAR);

        this.add([bgBottom, shine, wheel, cursor, backButton, spinButton, buttonText, haveTickets,ticket1,ticket2, chancesInfo,autoRotationText, campaignInfo, shine2, sectorHighlight]); // dec1, dec2,progress
        self.elements.forEach( e => {if(e){this.add([e]);}});
        this.bringToTop(cursor);
        this.bringToTop(sectorHighlight);

        PlayerStore.fetchWheelCampaignStatus().then((s: WheelStatusDto) => {
            let rulesText = TextUtils.addTextByFamily(scene, StringUtils.formatString(Tr('camp.wheel.limit'), s.value, s.valueMax),
                0, 115+338-46+13 -15,
                '#666666', 11, 'normal', 450, Fonts.MYRIADPRO_REGULAR);

            let dateText = TextUtils.addTextByFamily(scene, Tr('cmp.dates') + s.dates, 0, 115+338-46+13,
                '#666666', 11, 'normal', 420, Fonts.MYRIADPRO_REGULAR);

            self.add([dateText, rulesText]);
        });

    }

    protected getRewardDesc(c:ChestContentType): string {
        switch (c)  {
            case ChestContentType.TICKETS:
                return Tr('tickets.received');
            case ChestContentType.HERO:
                return Tr('hero.received');
            case ChestContentType.GEMS:
                return Tr('gems.received');
            case ChestContentType.ATTACK_TO_ALL:
            case ChestContentType.ATTACK_TO_ONE:
            case ChestContentType.ATTACK_PERCENT_TO_ONE:
            case ChestContentType.ATTACK_PERCENT_TO_ALL:
                return Tr('attack.increased');
            case ChestContentType.DEFENCE_TO_ALL:
            case ChestContentType.DEFENCE_TO_ONE:
            case ChestContentType.DEFENCE_PERCENT_TO_ONE:
            case ChestContentType.DEFENCE_PERCENT_TO_ALL:
                return Tr('defence.increased');
            case ChestContentType.HEALTH_TO_ALL:
            case ChestContentType.HEALTH_TO_ONE:
            case ChestContentType.HEALTH_PERCENT_TO_ONE:
            case ChestContentType.HEALTH_PERCENT_TO_ALL:
                return Tr('health.increased');
            case ChestContentType.RED_CRYSTALS:
            case ChestContentType.BLUE_CRYSTALS:
                return Tr('crystals.received');
            case ChestContentType.ARTIFACT:
                return Tr('artifact.received');
            case ChestContentType.FORCE:
                return Tr('force.received');
        }
        return Tr('reward.received');
    }

    protected onClose(): void {

    }

    targetTimeMillis = new Date().getTime();

    public update(){
        let deltaLeft = this.targetTimeMillis -  new Date().getTime();

        if (this.targetAngle > this.currentAngle) {
            let x = 0;
            let y = -20;
            let radius = 130;
            let angleInRadian = 0;
            let angleInRadianWas = this.currentAngle / 180 * Math.PI

            if (PlayerStore.isWheelAutoRotate()){
                angleInRadian = this.targetAngle /180 * Math.PI;
                this.currentAngle = this.targetAngle;
            } else {
                this.currentAngle = this.targetAngle - deltaLeft/1000 * CampaignWheelPanel2.ANGLE_PER_SECOND;
                angleInRadian = Math.min(this.currentAngle, this.targetAngle)/180 * Math.PI;
            }

            //angle per second:
            this.setAngleForElements(x * CU.S, y * CU.S, angleInRadian - angleInRadianWas, radius);
            this.wheel.setAngle(angleInRadian / Math.PI * 180);

        } else if (this.targetAngle > 0) {
            this.targetAngle = 0;
            this.currentAngle = 0;
            this.srcAngle = 0;
            this.updaters.forEach(u=>{u()});
            this.onStopWheelCallback && this.onStopWheelCallback();
        }

    }

    private setAngleForElements(x:number, y:number, angle:number, radius:number ){
        // Сами картинки:
        Phaser.Actions.RotateAroundDistance(this.elements.filter(e => e.originY == 0.5), //TODO костыль
            {"x": x, "y": y}, angle, radius * CU.S);

        // Тексты:
        Phaser.Actions.RotateAroundDistance(this.elements.filter(e => e.originY == 0.49),
            {"x": x, "y": y + 50 * CU.S}, angle, radius * CU.S);

        // Иконки к текстам (атака, защита, здоровье)
        this.elements.filter(e => e.originY == 0.48 && e.name).forEach(
            e => {
                Phaser.Actions.RotateAroundDistance([e], {
                    "x": x + Number(e.name),
                    "y": y + 50 * CU.S
                }, angle, radius * CU.S);
            }
        );
    }

    private updateState(dto:WheelStatusDto, onSpin?:boolean){
        if(!dto.rewards) {
            console.log("self.dto!!!!!", dto)
        }
        if(dto.rewards){
            this.dto = Object.assign({}, dto);
            this.tickets  = PlayerStore.getPlayer().tickets;
            this.updaters.forEach(u=>{u()});
            this.drawRewards(this.elements, onSpin);
            this.elements.forEach( e => {if(e){this.add(e)}});
            this.bringToTop(this.cursor);
        }
    }

    private calculateTargetAngle(dto: WheelStatusDto): number{
        let angle = 0;
        if (dto.rewards.filter(r=> r.chosen).length > 0){
            let chosen = dto.rewards.filter(r=> r.chosen)[0];
            angle = Math.PI * 2 * (1 - (chosen.sectorNumber+1)/8 + 1/16 ) + Math.PI * 2;
        }
        return angle;
    }

    private getSpinText(dto:WheelStatusDto): string{
        if (dto.freeSpins > 0) {
            return Tr('spin.free');
        }
        return Tr('spin.for') + this.dto.ticketsForSpin;
    }

    private getAvailableSpinsText(dto:WheelStatusDto, tickets:number): string{
        if (dto.freeSpins > 0) {
            return Tr('you.have.free.spins') + dto.freeSpins;
        }
        return Tr('you.have') + tickets;
    }

    private drawRewards(elements: (Phaser.GameObjects.Sprite|Phaser.GameObjects.Text|CreaturePanel)[], onSpin?:boolean){
        elements.forEach(e=>{if(e){e.visible =false; e.destroy()}});
        while(elements.length >0){
            elements.pop();
        }
        let step = 2 * Math.PI / this.dto.rewards.length;
        // let angle = step * 2 + this.wheel.angle/180*this.PI + (this.wheel.angle == 0? step*1/2 : 0); //нумерация по часовой стрелке
        let angle = step * 2 + this.wheel.angle/180 * Math.PI + step*1/2; //нумерация по часовой стрелке
        let x = 0;
        let y = -20;
        let rad = 130;
        this.dto.rewards.forEach((r:WheelContentDto) => {
            let contents = this.processContent(r, x - Math.cos(angle + step*r.sectorNumber)*rad, y - Math.sin(angle+ step*r.sectorNumber)*rad, onSpin);
            contents.forEach(e=>{if(e){elements.push(e)}});
        });
    }

    private processContent(c: WheelContentDto, x: number, y:number, onSpin?:boolean): (Phaser.GameObjects.Sprite|Phaser.GameObjects.Text|CreaturePanel)[]  {
        let xx= x;
        let yy= y;
        let icon = undefined;
        let icon2 = undefined;
        let text = undefined

        switch (c.chestContentType) {
            case ChestContentType.GEMS:
                icon = SpriteUtils.addSprite(this.scene, x, y, Keys.ATLAS_BANK, Keys.UI_SHOP_GEMS_1);
                //this.add(icon);
                // text = this.setupText( String(c.gems) + Tr('izumrudov'), xx, yy, c.chosen, onSpin);
                text = this.setupText(String(c.gems), xx, yy, c.chosen, onSpin);
                break;
            case ChestContentType.FORCE:
                icon = SpriteUtils.addSprite(this.scene, x, y, Keys.ATLAS_FORCES_LARGE, ForceUtils.getImage(c.force));
                SpriteUtils.scale(icon, 0.6);
                //this.add(icon);
                // text = this.setupText(TrSpace('force') + CreatureUtils.getClassNameGenetive(c.force), xx, yy, c.chosen, onSpin);
                text = this.setupText("", xx, yy, c.chosen, onSpin);
                break;
            case ChestContentType.ATTACK_TO_ALL:
                icon = SpriteUtils.addSprite(this.scene, x, y, Keys.ATTACK_TO_ALL);
                //this.add(icon);
                // text = this.setupText(`${Tr('ataka')} + ${c.skillToAll} ${Tr('all.her')}`, xx, yy, c.chosen, onSpin);
                text = this.setupText(`+${SkillUtils.formatValue(c.skillToAll)}`, xx, yy, c.chosen, onSpin);
                icon2 = SpriteUtils.addSprite(this.scene, text.x / CU.S + text.width/2 / CU.S + 10, text.y / CU.S, Keys.IMG_WHITE_SWORD);
                icon2.name = String(text.width/2 + 10);
                break;
            case ChestContentType.DEFENCE_TO_ALL:
                icon = SpriteUtils.addSprite(this.scene, x, y, Keys.DEFENCE_TO_ALL);
                // this.add(icon);
                //  text = this.setupText(`${Tr('zaschita')} + ${c.skillToAll} ${Tr('all.her')}`, xx, yy, c.chosen, onSpin);
                text = this.setupText(`+${SkillUtils.formatValue(c.skillToAll)}`, xx, yy, c.chosen, onSpin);
                icon2 = SpriteUtils.addSprite(this.scene, text.x / CU.S + text.width/2 / CU.S + 10, text.y / CU.S, Keys.IMG_WHITE_SHIELD);
                icon2.name = String(text.width/2 + 10);
                break;
            case ChestContentType.HEALTH_TO_ALL:
                icon = SpriteUtils.addSprite(this.scene, x, y, Keys.HEALTH_TO_ALL);
                // this.add(icon);
                //  text = this.setupText(`${Tr('zdorove')} + ${c.skillToAll} ${Tr('all.her')}`, xx, yy, c.chosen, onSpin);
                text = this.setupText(`+${SkillUtils.formatValue(c.skillToAll)}`, xx, yy, c.chosen, onSpin);
                icon2 = SpriteUtils.addSprite(this.scene, text.x / CU.S + text.width/2 / CU.S + 10, text.y / CU.S, Keys.IMG_WHITE_HEART);
                icon2.name = String(text.width/2 + 10);
                break;
            case ChestContentType.ATTACK_TO_ONE:
                icon = SpriteUtils.addSprite(this.scene, x, y, Keys.ATLAS_IC_100, Keys.IC_100_ATTACK);
                //this.add(icon);
                // text = this.setupText(`${Tr('ataka')} + ${c.skillToOne} ${Tr('one.her')}`, xx, yy, c.chosen, onSpin);
                text = this.setupText(`+${SkillUtils.formatValue(c.skillToOne)}`, xx, yy, c.chosen, onSpin);
                icon2 = SpriteUtils.addSprite(this.scene, text.x / CU.S + text.width/2 / CU.S + 10, text.y / CU.S, Keys.IMG_WHITE_SWORD);
                icon2.name = String(text.width/2 + 10);
                break;
            case ChestContentType.DEFENCE_TO_ONE:
                icon = SpriteUtils.addSprite(this.scene, x, y, Keys.ATLAS_IC_100, Keys.IC_100_DEFENCE);
                //this.add(icon);
                // text = this.setupText(`${Tr('zaschita')} + ${c.skillToOne} ${Tr('one.her')}`, xx, yy, c.chosen, onSpin);
                text = this.setupText(`+${SkillUtils.formatValue(c.skillToOne)}`, xx, yy, c.chosen, onSpin);
                icon2 = SpriteUtils.addSprite(this.scene, text.x / CU.S + text.width/2 / CU.S + 10, text.y / CU.S, Keys.IMG_WHITE_SHIELD);
                icon2.name = String(text.width/2 + 10);
                break;
            case ChestContentType.HEALTH_TO_ONE:
                icon = SpriteUtils.addSprite(this.scene, x, y, Keys.HEALTH_TO_ONE);
                //this.add(icon);
                // text = this.setupText(`${Tr('zdorove')} +${c.skillToOne} ${Tr('one.her')}`, xx, yy, c.chosen, onSpin);
                text = this.setupText(`+${SkillUtils.formatValue(c.skillToOne)}`, xx, yy, c.chosen, onSpin);
                icon2 = SpriteUtils.addSprite(this.scene, text.x / CU.S + text.width/2 / CU.S + 10, text.y / CU.S, Keys.IMG_WHITE_HEART);
                icon2.name = String(text.width/2 + 10);
                break;
            case ChestContentType.ARTIFACT:
                icon = SpriteUtils.addSprite(this.scene, x, y, c.artifactAtlas, c.artifactId);
                text = this.setupText(c.artifactEffect, xx, yy, c.chosen, onSpin);
                console.log("effect: " + c.artifactEffect)
                // text.text = text.text.replace('Attack','').replace('Атака','').replace('Protection','').replace('Защита','').replace('Health','').replace('Здоровье','').replace('+',"");
                text.text = text.text.replace(Tr('ataku'),'').replace(Tr('zaschita'),'').replace(Tr('zdorove'),'').replace('+',"");
                // if(c.artifactEffect.startsWith("Attack") || c.artifactEffect.startsWith("Атака")){
                if(c.artifactEffect.startsWith(Tr('ataku'))){
                    icon2 = SpriteUtils.addSprite(this.scene, text.x / CU.S + text.width/2 / CU.S + 10, text.y / CU.S, Keys.IMG_WHITE_SWORD);
                    icon2.name = String(text.width/2 + 10);
                // } else if(c.artifactEffect.startsWith("Protection") || c.artifactEffect.startsWith("Защита")){
                } else if(c.artifactEffect.startsWith(Tr('zaschita'))){
                    icon2 = SpriteUtils.addSprite(this.scene, text.x / CU.S + text.width/2 / CU.S + 10, text.y / CU.S / CU.S, Keys.IMG_WHITE_SHIELD);
                    icon2.name = String(text.width/2 + 10);
                } else {
                    icon2 = SpriteUtils.addSprite(this.scene, text.x / CU.S + text.width/2 / CU.S + 10, text.y / CU.S, Keys.IMG_WHITE_HEART);
                    icon2.name = String(text.width/2 + 10);
                }
                break;
            case ChestContentType.HERO:
                let creaturePanel = new CreaturePanel(this.scene!, x, y, c.creature, () => {}, false);
                creaturePanel.setHealthVisible();
                text = this.setupText("*", xx, yy, c.chosen, onSpin);
                icon = creaturePanel;
                SpriteUtils.scale(icon, 0.7);
                //this.add([creaturePanel]);
                break;
            case ChestContentType.RED_CRYSTALS:
                icon = SpriteUtils.addSprite(this.scene, x, y, Keys.IMG_RES_CRYSTAL);
                text = this.setupText( TextUtils.formatMoney(c.redCrystals), xx, yy, c.chosen, onSpin);
                break;
            case ChestContentType.BLUE_CRYSTALS:
                icon = SpriteUtils.addSprite(this.scene, x, y, Keys.IMG_RES_ELIXIR);
                text = this.setupText( TextUtils.formatMoney(c.blueCrystals), xx, yy, c.chosen, onSpin);
                break;
            case ChestContentType.TICKETS:
                icon = SpriteUtils.addSprite(this.scene, x, y, Keys.IMG_TICKET_BIG);
                text = this.setupText( String(c.tickets), xx, yy, c.chosen, onSpin);
                break;
            case ChestContentType.ELEPHANT:
            case ChestContentType.SNAKE:
            case ChestContentType.EAGLE:
            case ChestContentType.HEALTH_PERCENT_TO_ALL:
            case ChestContentType.HEALTH_PERCENT_TO_ONE:
            case ChestContentType.ATTACK_PERCENT_TO_ALL:
            case ChestContentType.ATTACK_PERCENT_TO_ONE:
            case ChestContentType.DEFENCE_PERCENT_TO_ALL:
            case ChestContentType.DEFENCE_PERCENT_TO_ONE:
            case ChestContentType.PORTAL:
            case ChestContentType.AMETIST:
            case ChestContentType.BOOSTER:
            case ChestContentType.HERO_RANK:
            case ChestContentType.SLOT_UNLOCK:
                icon = SpriteUtils.addSprite(this.scene, x, y, Keys.IMG_TICKET_BIG);
                text = this.setupText( String(c.tickets), xx, yy, c.chosen, onSpin);
                break;

        }
        // text.text = c.sectorNumber + " " + text.text;
        if(icon.scaleX == CU.S && icon.scaleY == CU.S) {
            SpriteUtils.scale(icon, 0.8);
        }
        let res = [text, icon];
        if(icon2){
            SpriteUtils.scale(icon2, 0.7);
            icon2.setOrigin(0.5 , 0.48);//TODO костыль
            res.push(icon2);
        }
        return res;

    }

    private setupText(content: string, xx: number, yy: number, marked?: boolean, onSpin?:boolean): Phaser.GameObjects.Text {
        let text = TextUtils.addTextByFamily(this.scene, content,
            // xx, yy + 50, marked? '#89fa78' : '#ffffff', marked? 14: 11, 'normal', 140, Fonts.MYRIADPRO_BOLD);
            xx, yy + 50,  '#ffffff', 11, 'normal', 140, Fonts.MYRIADPRO_BOLD);

        if(marked){
            this.choosenText = text;
        }

        SpriteUtils.scale(text, onSpin && !marked? 1 / CU.S : 0.5 / CU.S).setOrigin(0.5, 0.49); //TODO Костыль
        let g = 30;
        let t0 = 0.45;
        let v = (1 + g*t0*t0/2) / t0;
        if ((!onSpin || marked)) {
            this.scene!.tweens.add({
                targets: text,
                delay: 0,
                duration: t0 * 700,
                props: {
                    scale: {value: 1.0, ease: (t: number) => v * t * t0 - g * t * t * t0 * t0 / 2},
                }
            });
        }

        return text;
    }


}